import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import Spinner from '../../components/spinner/Spinner';
import { ChangePasswordStep2Service } from '../../services/api';
import ChangePassword from './ChangePassword';
import { toast } from 'react-toastify';

//Componentes

function ChangePasswordContainer() {
    const [loader, setLoader] = useState(false);
    const [passwordSent, setPasswordSent] = useState(false);

    const token = useParams().token;

    const navigate = useNavigate();

    const { register, handleSubmit, watch, setError, formState } = useForm();

    const onSubmitPassword = async (data) => {
        try {
            setLoader(true);

            delete data.confirmPassword;

            const res = await ChangePasswordStep2Service.send({
                token,
                ...data,
            });

            if (res) {
                setPasswordSent(true);
            }

            setLoader(false);
        } catch (err) {
            toast('No se pudo enviar la clave', { type: 'error' });
            setLoader(false);
            console.error(err);
        }
    };

    return loader ? (
        <Spinner />
    ) : (
        <ChangePassword
            functions={{
                register,
                handleSubmit,
                watch,
                setError,
                formState,
                onSubmitPassword,
            }}
            states={{ passwordSent }}
        />
    );
}

export default ChangePasswordContainer;
